import React from 'react'

const ResultWrapper = ({ result, backToHome }) => {
  return (
    <div className='warranty-wrapper'>
      <div>
        <svg
          onClick={backToHome}
          className='btn-back'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M14 5l7 7m0 0l-7 7m7-7H3'
          />
        </svg>
        <span className='msg-back'>{wck_app.back_button_field}</span>
      </div>
      <section className='lookup-result' id={result.status}>
        <b>{result.msg}</b> <br />
        {result.status === 'ok' && (
          <>
            {wck_app.product_field}: <b>{result.product}</b> <br />
            {wck_app.buyer_field}: <b>{result.customer_name}</b> <br />
            {wck_app.start_date_field}: <b dir='ltr'>{result.start_at}</b>{' '}
            <br />
            {wck_app.end_date_field}: <b dir='ltr'>{result.end_at}</b> <br />
            {result.agent && (
              <>
                {wck_app.agent_field}:{' '}
                <b>
                  {result.agent} / {result.agent_code} / {result.agent_address}
                </b>
              </>
            )}
          </>
        )}
      </section>
    </div>
  )
}

export default ResultWrapper
